module.exports = __webpack_public_path__ + "img/icon-17.845bbabe.png";